import React from "react";
import "./BigTextSection.scss";
import { motion } from "framer-motion";
const BigTextSection = React.memo(() => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
      className="bigTextSectionDiv"
    >
      <h2 className="bigText">
        Our current installed capacity is <span>400 Tons</span> per Annum which
        comprises of <span>320 Tons</span> of mass production Ceramics and
        <span>80 Tons</span> of Customized Ceramics.
      </h2>
    </motion.section>
  );
});
export default BigTextSection;
